<template>
  <div>
    <div class="table-responsive full_table mt-0">
      <table class="table caption-top">
        <thead class="bg_table_header">
          <tr>
            <th v-if="!byInstitucional" class="col-md-1 py-3">ID<button v-if="withOrderBy" class="bt_order_asc bt_order" @click="orderBy(3)"></button><button v-if="withOrderBy" class="bt_order_desc bt_order" @click="orderBy(-3)"></button></th>
            <th class="col-md-4 py-3 pl-4">{{ $t('label.nome') }}<button v-if="withOrderBy" class="bt_order_asc bt_order" @click="orderBy(1)"></button><button v-if="withOrderBy" class="bt_order_desc bt_order" @click="orderBy(-1)"></button></th>
            <th class="col-md-5 py-3">{{ $t('label.sobrenome') }}<button v-if="withOrderBy" class="bt_order_asc bt_order" @click="orderBy(2)"></button><button v-if="withOrderBy" class="bt_order_desc bt_order" @click="orderBy(-2)"></button></th>
            <th class="col-md-2 py-3 pr-4 text-right">{{ $t('label.acoes') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="$store.state.countList === 0"><td :colspan="byInstitucional ? 3 : 4" class="text-center">{{ $t('message.noRecords') }}</td></tr>
          <tr v-else v-for="item in items" :key="item.contact_id">
            <td v-if="!byInstitucional" class="py-3">{{item.contact_id}}</td>
            <td class="py-3 pl-4">{{item.name}}</td>
            <td class="py-3">{{item.surname}}</td>
            <td class="py-3">
              <ul class="acoes text-right pr-1">
                <template v-if="byInstitucional">
                  <li>
                    <a @click="actionByInstitucional(item)"><span class="visualizar"></span></a>
                  </li>
                </template>
                <template v-else>
                  <li>
                    <a @click="action($actionEdit, item)" v-if="item.pending_analysis"><span class="nao-validado"></span></a>
                    <a @click="action($actionEdit, item)" v-else><span class="validar"></span></a>
                  </li>
                  <li>
                    <a @click="action($actionEdit, item)"><span class="editar"></span></a>
                  </li>
                  <li>
                    <a @click="action($actionDelete, item)" v-if="$store.state.user && $store.state.user.perfilUser === 'administrator'"><span class="apagar"></span></a>
                  </li>
                </template>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <TablePagination v-on:searchTable="search()"/>
  </div>
</template>

<script>
import axios from 'axios'
import TablePagination from '@/components/shared/TablePagination'
export default {
  name: 'ColaboradoresTable',
  components: { TablePagination },
  props: {
    items: Array,
    byInstitucional: {
      type: Boolean,
      default: false
    },
    withOrderBy: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      dataOrderBy: {}
    }
  },
  methods: {
    action: function (action, item) {
      if (action === this.$actionDelete) {
        if (confirm(this.$t('message.confirmDel'))) {
          this.delete(item)
        }
      } else {
        if (this.$route.name === 'AdminHome') {
          this.$store.state.dashboard.currentPage = this.$store.state.currentPage
        }
        this.$router.push({ name: 'AdminColaboradoresForm', params: { id: item.contact_id } })
      }
    },
    delete: function (item) {
      axios.delete(`/Contact/${item.contact_id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.search()
        })
    },
    search: function () {
      this.$emit('search')
    },
    actionByInstitucional: function (item) {
      this.$emit('actionByInstitucional', item)
    },
    orderBy: function (num) {
      if (num === 1) {
        this.$store.state.dataOrderBy.OrderByNameAcs = true
        this.$store.state.dataOrderBy.OrderByNameDesc = !this.$store.state.dataOrderBy.OrderByNameAcs
      }
      if (num === -1) {
        this.$store.state.dataOrderBy.OrderByNameDesc = true
        this.$store.state.dataOrderBy.OrderByNameAcs = !this.$store.state.dataOrderBy.OrderByNameDesc
      }
      if (num === 2) {
        this.$store.state.dataOrderBy.OrderBySurnameAcs = true
        this.$store.state.dataOrderBy.OrderBySurnameDesc = !this.$store.state.dataOrderBy.OrderBySurnameAcs
      }
      if (num === -2) {
        this.$store.state.dataOrderBy.OrderBySurnameDesc = true
        this.$store.state.dataOrderBy.OrderBySurnameAcs = !this.$store.state.dataOrderBy.OrderBySurnameDesc
      }
      if (num === 3) {
        this.$store.state.dataOrderBy.OrderByIDAcs = true
        this.$store.state.dataOrderBy.OrderByIDDesc = !this.$store.state.dataOrderBy.OrderByIDAcs
      }
      if (num === -3) {
        this.$store.state.dataOrderBy.OrderByIDDesc = true
        this.$store.state.dataOrderBy.OrderByIDAcs = !this.$store.state.dataOrderBy.OrderByIDDesc
      }
      this.$emit('orderBy', this.$store.state.dataOrderBy)
    }
  }
}
</script>
